export enum HorizontalAlignment {
    Left = "Left",
    Right = "Right",
    Center = "Center"
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/enums/horizontal-alignment.ts